// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__1MPew","checkboxInput--secondary":"Checkbox_checkboxInput--secondary__1Baa6","checkboxInputChecked":"Checkbox_checkboxInputChecked__fEHoQ"};